import { Outlet } from 'react-router-dom';
import { AppBar } from '@bpba/ui-components';

export const Layout = () => (
  <>
    <AppBar title="Estudios Económicos" titleStyle={{ animation: 'appBarFadeIn 0.4s ease-out both' }} />
    <main id="main-content">
      <Outlet />
    </main>
  </>
);
